<template>
  <div class="laywrap">
    <Header />
    <Sidebar />
    <div class="rightPanel main">
      <tagView />
        <transition name="fade-transform" mode="out-in" >
            <router-view />
        </transition>
    </div>
  </div>
</template>

<script>
import Header from "@/views/layout/Header.vue";
import Content from "@/views/layout/Content.vue";
import Sidebar from "@/views/layout/Sidebar.vue";
import tagView from "@/views/layout/tagView";

export default {
  components: {
    Header,
    Content,
    Sidebar,
    tagView,
  },
  data() {
    return {};
  },
  computed: {},

  created() {},

  mounted() {},

  methods: {},
};
</script>
<style scoped>
.laywrap {
  min-width: 1200px;
}

.aside {
  background: #fff;
  width: 300px;
  box-sizing: border-box;
  box-shadow: 1px 0px 30px 0px rgba(0, 0, 0, 0.04);
}

.header {
  background: #fff;
  padding: 0 !important;
  box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.04);
}

@media screen and (max-width: 1366px) {
  .aside {
    width: 250px !important;
  }
}

.other {
  flex: 1;
  width: 99%;
  background: #fff;
  margin-left: -11px;
  overflow: hidden;
}
</style>

